import api from './api';

const userUrl = '/users';

export function getAssignableUsers() {
  return api.get(`${userUrl}/assignable-users`).catch(err => {
    return err;
  });
}

export function assignUser(userId: number, claimNotificationId: number) {
  return api.post(`${userUrl}/assign-user`, {
    userId: userId,
    claimNotificationId: claimNotificationId,
  }).catch(err => {
    console.error(err);
    return err;
  });
}

